import React, { useState, lazy, createElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, CheckCircle2, ChevronRight, Crown, Sparkles, Zap, BookOpen, Gem, Headphones, Eye } from 'lucide-react';
import { ShopUpsellPopup } from '../components/ShopUpsellPopup';
export function ShopPage() {
  const navigate = useNavigate();
  const [isUpsellOpen, setIsUpsellOpen] = useState(false);
  const [expandedBonus, setExpandedBonus] = useState<number | null>(null);
  const handleGuideOnly = () => {
    window.location.href = 'https://www.betterdailyguides.com/cart/51934295621934:1';
  };
  const handleGuidePlusBonus = () => {
    setIsUpsellOpen(true);
  };
  const handleFullPackage = () => {
    window.location.href = 'https://www.betterdailyguides.com/cart/51937439318318:1';
  };
  const bonuses = [{
    title: 'BONO 1 - THE FLOW MAP 888',
    subtitle: 'Tu Brújula de Sintonía Universal',
    desc: 'El mapa visual exacto para navegar las frecuencias de abundancia. Identifica dónde estás y cómo fluir hacia el siguiente nivel de riqueza. 🗺️✨',
    fullDesc: 'Este no es un mapa ordinario; es la cartografía geométrica de la abundancia. Aquí identificarás las coordenadas exactas de tu frecuencia actual y, por primera vez, verás el camino codificado para ascender a las esferas de riqueza que el 99% ignora. Navega el flujo cósmico y deja de forcejear con la escasez. El universo no te niega nada; solo estabas usando el mapa equivocado. 🗺️✨',
    img: 'https://cdn.magicpatterns.com/uploads/7h1Tm5ire6DHJh7WNSqPJP/BONO_1_1X1.webp',
    icon: BookOpen
  }, {
    title: 'BONO 2 - La Llave Maestra del Oro Líquido',
    subtitle: 'El Activador de Portales',
    desc: 'El secreto para activar la sintonía constante. La herramienta definitiva para abrir portales de oportunidad y recepción financiera diaria. 🗝️🏺',
    fullDesc: 'Poseer este secreto es poseer el interruptor de la recepción constante. La Alquimia del Oro Líquido es el estado donde tu energía se vuelve magnética. Con esta herramienta, abrirás portales de opulencia diaria, convirtiendo tu realidad en un imán que atrae oportunidades financieras, sincronías de éxito y una recepción de fondos que fluye sin interrupciones. Toma la llave y abre la bóveda de la creación. 🗝️🏺',
    img: 'https://cdn.magicpatterns.com/uploads/r7VbD2yCinmF3hAebSSDnf/BONO_2_1X1.webp',
    icon: Zap
  }, {
    title: 'BONO 3 - Protocolo de Manifestación Acelerada',
    subtitle: 'El Colapso del Tiempo',
    desc: 'Guía de pasos críticos para reducir el tiempo entre tu decreto y la realidad física. Diseñado para quienes buscan resultados en tiempo récord. ⚡🏹',
    fullDesc: 'El tiempo es una ilusión que tu mente ha usado para retrasar tu abundancia. Este Protocolo es la guía de ingeniería metafísica para colapsar la distancia entre tu Decreto y la Materia. Aprende a condensar meses de espera en días de realización física. Es el atajo de los maestros para precipitar la riqueza desde el plano etérico directamente a tus cuentas bancarias. No esperes por tu futuro; ordénalo ahora. ⚡🏹',
    img: 'https://cdn.magicpatterns.com/uploads/tTpeyVAPpLx9jHzMiho5j2/BONO_3_1X1.webp',
    icon: Sparkles
  }, {
    title: 'BONO 4 - El Código de Riqueza Suprema',
    subtitle: 'El Blindaje de tu Linaje',
    desc: 'El pilar final del sistema. Un conjunto de frecuencias y mandatos de alto nivel para blindar tu nueva mentalidad de abundancia absoluta. 🏛️👑',
    fullDesc: 'El pilar final. El sello de platino sobre tu nueva identidad. Este código contiene las frecuencias vibracionales y los Mandatos de Poder necesarios para blindar tu mente contra cualquier retorno a la escasez. Es el software de los soberanos; una reprogramación de alto nivel que asegura que tu mentalidad de Riqueza Suprema sea inquebrantable, eterna y majestuosa. Bienvenidos a la cima del mundo. 🏛️👑',
    img: 'https://cdn.magicpatterns.com/uploads/qA2iDrsNUDttZ8CDsZWkTF/BONO_4_1X1.webp',
    icon: Gem
  }];
  return <div className="min-h-screen bg-[#0A0A0B] font-sans text-white selection:bg-gold/30 selection:text-gold overflow-x-hidden w-full pb-12 sm:pb-20" data-id="element-401">
      {/* Header */}
      <header className="sticky top-0 z-[90] bg-[#0A0A0B]/90 backdrop-blur-md border-b border-gold/15 h-[56px] sm:h-[70px] flex items-center px-3 sm:px-[5%]" data-id="element-402">
        <button onClick={() => navigate('/')} className="flex items-center gap-1.5 sm:gap-2 text-white/70 hover:text-gold transition-colors text-xs sm:text-sm font-bold uppercase tracking-wider" data-id="element-403">
          <ArrowLeft className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-404" />
          <span className="hidden sm:inline" data-id="element-405">Volver</span>
        </button>
        <div className="absolute left-1/2 -translate-x-1/2 font-serif italic text-gold text-base sm:text-xl font-bold tracking-[2px]" data-id="element-406">
          EL CÓDIGO 888
        </div>
      </header>

      <main className="max-w-[1000px] mx-auto px-3 sm:px-[5%] pt-8 sm:pt-16" data-id="element-407">
        {/* SECTION 1: Guide + 1 Bonus */}
        <motion.section initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="mb-10 sm:mb-24" data-id="element-408">
          <div className="text-center mb-6 sm:mb-8" data-id="element-409">
            <h1 className="font-serif text-2xl sm:text-4xl md:text-5xl font-black mb-3 sm:mb-4 leading-tight" data-id="element-410">
              Personaliza tu <span className="text-gold" data-id="element-411">Experiencia</span>
            </h1>
            <p className="text-white/70 text-sm sm:text-lg max-w-2xl mx-auto" data-id="element-412">
              Elige el nivel de profundidad que deseas para tu reprogramación
              financiera.
            </p>
          </div>

          <div className="bg-white/5 border border-gold/20 rounded-2xl sm:rounded-3xl p-4 sm:p-8 md:p-10 relative overflow-hidden shadow-[0_0_50px_rgba(212,175,55,0.05)]" data-id="element-413">
            <div className="absolute top-0 right-0 w-48 sm:w-64 h-48 sm:h-64 bg-gold/10 rounded-full blur-[80px] -translate-y-1/2 translate-x-1/2 pointer-events-none" data-id="element-414" />

            <div className="relative z-10 grid grid-cols-1 md:grid-cols-[1fr_auto_1fr] gap-5 sm:gap-8 items-center" data-id="element-415">
              {/* Left: Guide */}
              <div className="text-center md:text-left" data-id="element-416">
                <h3 className="text-lg sm:text-xl font-black text-white mb-1 sm:mb-2" data-id="element-417">
                  La Guía Principal
                </h3>
                <p className="text-white/60 text-xs sm:text-sm mb-2 sm:mb-4" data-id="element-418">
                  El Código 888 Base
                </p>
                <div className="text-2xl sm:text-3xl font-black text-white" data-id="element-419">
                  $6.39
                </div>
              </div>

              {/* Middle: Plus */}
              <div className="flex justify-center" data-id="element-420">
                <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-gold/20 flex items-center justify-center text-gold font-black text-lg sm:text-xl border border-gold/30" data-id="element-421">
                  +
                </div>
              </div>

              {/* Right: Bonus */}
              <div className="text-center md:text-right" data-id="element-422">
                <div className="inline-block bg-gold/10 text-gold text-[9px] sm:text-[10px] font-black px-2.5 sm:px-3 py-1 rounded-full uppercase tracking-wider border border-gold/20 mb-2" data-id="element-423">
                  BONO RECOMENDADO
                </div>
                <h3 className="text-lg sm:text-xl font-black text-gold mb-1 sm:mb-2" data-id="element-424">
                  El Código de Riqueza Suprema
                </h3>
                <p className="text-white/60 text-xs sm:text-sm mb-2 sm:mb-4" data-id="element-425">
                  Agrega el bono por solo $6.39 más
                </p>
                <div className="text-2xl sm:text-3xl font-black text-gold" data-id="element-426">
                  $6.39
                </div>
              </div>
            </div>

            <div className="mt-6 sm:mt-10 pt-5 sm:pt-8 border-t border-white/10" data-id="element-427">
              <div className="flex flex-col items-center gap-4 sm:gap-6 sm:flex-row sm:justify-between" data-id="element-428">
                <div className="text-center sm:text-left" data-id="element-429">
                  <div className="text-xs sm:text-sm text-white/50 uppercase tracking-wider font-bold mb-1" data-id="element-430">
                    Precio Total
                  </div>
                  <div className="text-3xl sm:text-4xl font-black text-white" data-id="element-431">
                    $12.78
                  </div>
                </div>

                <div className="flex flex-col gap-3 sm:gap-4 sm:flex-row w-full sm:w-auto" data-id="element-432">
                  <button onClick={handleGuideOnly} className="px-5 sm:px-6 py-3 sm:py-4 rounded-xl border border-white/20 text-white/80 font-bold hover:bg-white/5 transition-colors text-xs sm:text-sm uppercase tracking-wider w-full sm:w-auto text-center" data-id="element-433">
                    SOLO LA GUÍA — $6.39
                  </button>
                  <button onClick={handleGuidePlusBonus} className="px-5 sm:px-8 py-3 sm:py-4 rounded-xl bg-gold text-dark font-black hover:scale-105 transition-transform shadow-[0_10px_30px_rgba(212,175,55,0.3)] text-xs sm:text-sm uppercase tracking-wider flex items-center justify-center gap-2 w-full sm:w-auto" data-id="element-434">
                    GUÍA + BONO — $12.78
                    <ChevronRight className="w-4 h-4" data-id="element-435" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </motion.section>

        {/* SECTION 2: Full Package */}
        <motion.section initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.8
      }} data-id="element-436">
          <div className="relative rounded-2xl sm:rounded-[2.5rem] overflow-hidden p-[2px]" data-id="element-437">
            <div className="absolute inset-0 bg-gradient-to-b from-gold via-gold/20 to-transparent" data-id="element-438" />

            <div className="relative bg-[#0c0c0e] rounded-2xl sm:rounded-[2.5rem] overflow-hidden" data-id="element-439">
              {/* Header Banner */}
              <div className="bg-gradient-to-r from-gold/20 via-gold/10 to-gold/20 border-b border-gold/20 py-4 sm:py-6 text-center px-3 sm:px-4" data-id="element-440">
                <div className="inline-block bg-gold/20 text-gold text-[10px] sm:text-xs font-black px-3 sm:px-4 py-1 sm:py-1.5 rounded-full uppercase tracking-[2px] sm:tracking-[3px] border border-gold/30 mb-3 sm:mb-4" data-id="element-441">
                  ★ BONO EXCLUSIVO ★
                </div>
                <h2 className="font-serif text-2xl sm:text-4xl md:text-5xl font-black text-white mb-1 sm:mb-2" data-id="element-442">
                  PAQUETE COMPLETO 888
                </h2>
                <p className="text-gold font-bold tracking-wider uppercase text-xs sm:text-base" data-id="element-443">
                  Tu Transformación Completa
                </p>
              </div>

              <div className="p-4 sm:p-10 md:p-12" data-id="element-444">
                <div className="text-center mb-6 sm:mb-10" data-id="element-445">
                  <h3 className="text-white/50 uppercase tracking-[2px] sm:tracking-[3px] font-bold text-xs sm:text-sm" data-id="element-446">
                    Todo lo que incluye
                  </h3>
                </div>

                {/* Bonus Detail View */}
                {expandedBonus !== null ? <motion.div key={`detail-${expandedBonus}`} initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                y: -20
              }} transition={{
                duration: 0.4
              }} className="mb-8 sm:mb-12" data-id="element-447">
                    <button onClick={() => setExpandedBonus(null)} className="flex items-center gap-2 text-white/60 hover:text-gold transition-colors text-xs sm:text-sm font-bold uppercase tracking-wider mb-6" data-id="element-448">
                      <ArrowLeft className="w-4 h-4" data-id="element-449" />
                      Regresar a todos los bonos
                    </button>

                    <div className="bg-white/5 border border-gold/20 rounded-xl sm:rounded-2xl overflow-hidden" data-id="element-450">
                      {/* Full image */}
                      <div className="w-full overflow-hidden relative" data-id="element-451">
                        <img src={bonuses[expandedBonus].img} alt={bonuses[expandedBonus].title} loading="eager" decoding="async" className="w-full h-auto object-cover" data-id="element-452" />
                      </div>

                      {/* Content */}
                      <div className="p-5 sm:p-8 md:p-10" data-id="element-453">
                        <div className="flex items-center gap-3 mb-4" data-id="element-454">
                          <div className="w-10 h-10 rounded-full bg-gold/20 flex items-center justify-center border border-gold/30 shrink-0" data-id="element-455">
                            {createElement(bonuses[expandedBonus].icon, {
                          className: 'w-5 h-5 text-gold'
                        })}
                          </div>
                          <div data-id="element-456">
                            <h3 className="text-gold font-black text-lg sm:text-xl leading-tight" data-id="element-457">
                              {bonuses[expandedBonus].title}
                            </h3>
                            <p className="text-white/50 text-xs sm:text-sm font-bold italic" data-id="element-458">
                              {bonuses[expandedBonus].subtitle}
                            </p>
                          </div>
                        </div>

                        <p className="text-white/85 text-sm sm:text-base leading-relaxed sm:leading-loose" data-id="element-459">
                          {bonuses[expandedBonus].fullDesc}
                        </p>

                        <button onClick={() => setExpandedBonus(null)} className="mt-6 sm:mt-8 flex items-center gap-2 text-gold hover:text-yellow-300 transition-colors text-xs sm:text-sm font-bold uppercase tracking-wider" data-id="element-460">
                          <ArrowLeft className="w-4 h-4" data-id="element-461" />
                          Regresar
                        </button>
                      </div>
                    </div>
                  </motion.div> /* Bonus Grid */ : <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-8 mb-8 sm:mb-12" data-id="element-462">
                    {bonuses.map((bono, idx) => <motion.div key={idx} whileHover={{
                  y: -5
                }} className="bg-white/5 border border-white/10 rounded-xl sm:rounded-2xl overflow-hidden group hover:border-gold/30 transition-colors" data-id="element-463">
                        <div className="aspect-[16/9] overflow-hidden relative" data-id="element-464">
                          <div className="absolute inset-0 bg-gradient-to-t from-[#0c0c0e] to-transparent z-10 opacity-60" data-id="element-465" />
                          <img src={bono.img} alt={bono.title} loading="lazy" decoding="async" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-466" />
                          <div className="absolute bottom-3 sm:bottom-4 left-3 sm:left-4 z-20 flex items-center gap-2" data-id="element-467">
                            <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-gold/20 backdrop-blur-md flex items-center justify-center border border-gold/30" data-id="element-468">
                              <bono.icon className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-gold" data-id="element-469" />
                            </div>
                          </div>
                        </div>
                        <div className="p-4 sm:p-6" data-id="element-470">
                          <h4 className="text-gold font-bold text-base sm:text-lg mb-1 leading-tight" data-id="element-471">
                            {bono.title}
                          </h4>
                          <p className="text-white/40 text-[10px] sm:text-xs font-bold italic mb-2 sm:mb-3" data-id="element-472">
                            {bono.subtitle}
                          </p>
                          <p className="text-white/70 text-xs sm:text-sm leading-relaxed mb-3 sm:mb-4" data-id="element-473">
                            {bono.desc}
                          </p>
                          <button onClick={() => setExpandedBonus(idx)} className="flex items-center gap-1.5 text-gold hover:text-yellow-300 transition-colors text-[11px] sm:text-xs font-bold uppercase tracking-wider group/btn" data-id="element-474">
                            <Eye className="w-3.5 h-3.5 sm:w-4 sm:h-4" data-id="element-475" />
                            <span data-id="element-476">Ver más</span>
                            <ChevronRight className="w-3 h-3 sm:w-3.5 sm:h-3.5 group-hover/btn:translate-x-0.5 transition-transform" data-id="element-477" />
                          </button>
                        </div>
                      </motion.div>)}
                  </div>}

                {/* Extra Features */}
                <div className="bg-gold/5 border border-gold/15 rounded-xl sm:rounded-2xl p-4 sm:p-8 mb-8 sm:mb-12 flex flex-col gap-5 sm:gap-8 sm:flex-row items-center justify-center text-center sm:text-left" data-id="element-478">
                  <div className="flex items-center gap-3 sm:gap-4" data-id="element-479">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-gold/20 flex items-center justify-center shrink-0" data-id="element-480">
                      <Headphones className="w-5 h-5 sm:w-6 sm:h-6 text-gold" data-id="element-481" />
                    </div>
                    <div data-id="element-482">
                      <h4 className="text-white font-bold text-sm sm:text-base mb-0.5 sm:mb-1" data-id="element-483">
                        Audios de Meditación Premium
                      </h4>
                      <p className="text-white/50 text-[10px] sm:text-xs" data-id="element-484">
                        Frecuencias 432Hz + 888Hz para meditación profunda
                      </p>
                    </div>
                  </div>
                  <div className="hidden sm:block w-px h-12 bg-white/10" data-id="element-485" />
                  <div className="flex items-center gap-3 sm:gap-4" data-id="element-486">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-gold/20 flex items-center justify-center shrink-0" data-id="element-487">
                      <Crown className="w-5 h-5 sm:w-6 sm:h-6 text-gold" data-id="element-488" />
                    </div>
                    <div data-id="element-489">
                      <h4 className="text-white font-bold text-sm sm:text-base mb-0.5 sm:mb-1" data-id="element-490">
                        Acceso inmediato y de por vida
                      </h4>
                      <p className="text-white/50 text-[10px] sm:text-xs" data-id="element-491">
                        Actualizaciones futuras incluidas
                      </p>
                    </div>
                  </div>
                </div>

                {/* Final CTA */}
                <div className="text-center max-w-md mx-auto" data-id="element-492">
                  <div className="mb-4 sm:mb-6" data-id="element-493">
                    <div className="text-4xl sm:text-6xl font-black text-gold drop-shadow-[0_0_30px_rgba(212,175,55,0.3)] mb-1 sm:mb-2" data-id="element-494">
                      $23
                    </div>
                    <div className="text-white/50 text-xs sm:text-sm uppercase tracking-wider font-bold" data-id="element-495">
                      Pago único · Todo incluido
                    </div>
                  </div>

                  <motion.button onClick={handleFullPackage} whileHover={{
                  scale: 1.03
                }} whileTap={{
                  scale: 0.98
                }} className="w-full bg-gradient-to-r from-gold via-yellow-400 to-gold text-dark font-black text-base sm:text-lg py-4 sm:py-5 rounded-xl sm:rounded-2xl shadow-[0_15px_40px_rgba(212,175,55,0.4)] flex items-center justify-center gap-2 uppercase tracking-wider" data-id="element-496">
                    EMPEZAR MI TRANSFORMACIÓN
                    <ChevronRight className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-497" />
                  </motion.button>

                  <div className="mt-4 sm:mt-6 flex items-center justify-center gap-2 text-white/40 text-[10px] sm:text-xs" data-id="element-498">
                    <CheckCircle2 className="w-3.5 h-3.5 sm:w-4 sm:h-4" data-id="element-499" />
                    <span data-id="element-500">Garantía de satisfacción 100%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.section>
      </main>

      <ShopUpsellPopup isOpen={isUpsellOpen} onClose={() => setIsUpsellOpen(false)} data-id="element-501" />
    </div>;
}